<template>
  <div
    v-show="isLoading"
    :class="{ 'no-top': isFoldazAppWebView }"
    class="loading"
  >
    <loading-cube />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LoadingCube from '@/components/ui/LoadingCube'

export default {
  components: {
    LoadingCube
  },

  computed: {
    ...mapState({
      isLoading: state => state.app.loading,
      isFoldazAppWebView: state => state.webview.active,
    })
  }
}
</script>

<style lang="sass" scoped>
@import '~styles/imports'

.loading
  display: flex
  align-items: center
  justify-content: center
  height: 100vh
  width: 100vw
  position: fixed
  top: rem-calc(85)
  left: 0
  z-index: 1100
  flex-direction: column
  user-select: none
  background: $color-white

  &.no-top
    top: 0
</style>



// WEBPACK FOOTER //
// src/components/app/Loading.vue